<div class="input-fileds">
    <div class="form-group">
      <label class="form-label">Product </label>
      <input type="text" class="form-control" placeholder="Enter Product Name" />
    </div>
  
    <div class="form-group">
      <label class="form-label">Product Name</label>
      <input type="text" class="form-control" placeholder="Enter Product Name" />
    </div>
  
    <div class="form-group">
      <label class="form-label">Product Name</label>
      <input type="text" class="form-control" placeholder="Enter Product Name" />
    </div>
  
    <div class="form-group">
      <label class="form-label">Product Name</label>
      <input type="text" class="form-control" placeholder="Enter Product Name" />
    </div>
    <div class="form-group">
      <label class="form-label">Product Name</label>
      <input type="text" class="form-control" placeholder="Enter Product Name" />
    </div>
  
    <div class="form-group">
      <label class="form-label">Product Dropdown</label>
      <select class="form-control">
        <option value="">Select Plant</option>
        <option>Option1</option>
        <option>Option2</option>
        <option>Option3</option>
      </select>
    </div>
  
  
    <div class="form-group">
      <button class="btn btnprimary">
        Submit
      </button>
  
    </div>
  </div>
  
  
  <div class="common-table ">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>S.no</th>
            <th>Produt Name</th>
            <th>Qty</th>
            <th>Order Date</th>
            <th>Payment Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Milk </td>
            <td>3</td>
            <td>01-05-2025</td>
            <td>Card</td>
  
          </tr>
          <tr>
            <td>2</td>
            <td>Rice </td>
            <td>5</td>
            <td>01-05-2025</td>
            <td>Card</td>
  
          </tr>
          <tr>
            <td>3</td>
            <td>Oil </td>
            <td>5</td>
            <td>01-05-2025</td>
            <td>Card</td>
  
          </tr>
          <tr>
            <td>4</td>
            <td>Bread </td>
            <td>1</td>
            <td>01-05-2025</td>
            <td>Card</td>
  
          </tr>
          <tr>
            <td>5</td>
            <td>Bread </td>
            <td>1</td>
            <td>01-05-2025</td>
            <td>Card</td>
  
          </tr>
  
        </tbody>
      </table>
    </div>
    <div class="table-pagination">
      <div class="pagination-count">
        <select>
          <option>10</option>
          <option>20</option>
          <option>30</option>
          <option>40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link" href="#" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li class="page-item"><a class="page-link" href="#">1</a></li>
        <li class="page-item"><a class="page-link" href="#">2</a></li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item"><a class="page-link" href="#">..</a></li>
        <li class="page-item"><a class="page-link" href="#">..</a></li>
        <li class="page-item"><a class="page-link" href="#">9</a></li>
        <li class="page-item"><a class="page-link" href="#">10</a></li>
        <li class="page-item">
          <a class="page-link" href="#" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <br>
<br>
<br>
<br>


  <!-- add product modal -->
  <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addproduct">
    Add Product
  </button>

<div class="modal fade" id="addproduct" tabindex="-1" aria-labelledby="addproductLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="addproductLabel">Modal title</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="input-fileds">
          <div class="form-group">
            <label class="form-label">Product name</label>
            <input type="text" class="form-control" placeholder="Enter Product Name" />
          </div>
        
          
        
          <div class="form-group">
            <label class="form-label">Product Dropdown</label>
            <select class="form-control">
              <option value="">Select Plant</option>
              <option>Option1</option>
              <option>Option2</option>
              <option>Option3</option>
            </select>
          </div>
        
        
       
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>

<br>
<br>
<br>
<br>
<!-- delete product modal -->

<button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#deleteproduct">
  delete Product
</button>

<div class="modal fade" id="deleteproduct" tabindex="-1" aria-labelledby="deleteproductLabel" aria-hidden="true">
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title fs-5" id="deleteproductLabel">delete product</h1>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
     <p>are you sure want to delete</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Confirm</button>
      <button type="button" class="btn btn-primary">cancel</button>
    </div>
  </div>
</div>
</div>